export const CHAT_URL = '/csrb/nma?pageContext=GR';
